import DecodeUrlFilePreview from './decodeUrlPreview';
import LocalFilePreview from './localFilePreview';

export default {
  DecodePreview: DecodeUrlFilePreview,
  LocalFilePreview: LocalFilePreview,
};
